/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DrawQualificationCustomWindow } from './DrawQualificationCustomWindow';
import {
    DrawQualificationCustomWindowFromJSON,
    DrawQualificationCustomWindowFromJSONTyped,
    DrawQualificationCustomWindowToJSON,
    DrawQualificationCustomWindowToJSONTyped,
} from './DrawQualificationCustomWindow';
import type { DrawQualificationScope } from './DrawQualificationScope';
import {
    DrawQualificationScopeFromJSON,
    DrawQualificationScopeFromJSONTyped,
    DrawQualificationScopeToJSON,
    DrawQualificationScopeToJSONTyped,
} from './DrawQualificationScope';

/**
 * Per-draw qualification gate. Composed onto the ACTIVE_CHALLENGE_MEMBER
 * pool — the pool source defines WHO is eligible by membership state,
 * qualification defines WHICH of those members has the activity required
 * to enter this specific draw.
 * 
 * scope NONE - every active member is in the pool. minPoints is ignored.
 * scope ROUND - members who earned >= minPoints points inside the round
 *   (displayTab:true segment) containing drawAt. minPoints defaults to 1.
 * scope CAMPAIGN - members whose campaign-total points sum is >= minPoints
 *   across every segment they hold. minPoints defaults to 1.
 * scope CUSTOM_WINDOW - members who earned >= minPoints inside the
 *   admin-supplied [customWindow.startAt, customWindow.endAt] window.
 *   Implementation: resolves which segment(s) the window overlaps and
 *   counts points in those segments. minPoints defaults to 1.
 * 
 * @export
 * @interface DrawQualification
 */
export interface DrawQualification {
    /**
     * 
     * @type {DrawQualificationScope}
     * @memberof DrawQualification
     */
    scope: DrawQualificationScope;
    /**
     * Minimum points required to qualify (default 1 for any activity-gated scope). Ignored when scope=NONE.
     * @type {number}
     * @memberof DrawQualification
     */
    minPoints?: number;
    /**
     * 
     * @type {DrawQualificationCustomWindow}
     * @memberof DrawQualification
     */
    customWindow?: DrawQualificationCustomWindow;
}



/**
 * Check if a given object implements the DrawQualification interface.
 */
export function instanceOfDrawQualification(value: object): value is DrawQualification {
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function DrawQualificationFromJSON(json: any): DrawQualification {
    return DrawQualificationFromJSONTyped(json, false);
}

export function DrawQualificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrawQualification {
    if (json == null) {
        return json;
    }
    return {
        
        'scope': DrawQualificationScopeFromJSON(json['scope']),
        'minPoints': json['minPoints'] == null ? undefined : json['minPoints'],
        'customWindow': json['customWindow'] == null ? undefined : DrawQualificationCustomWindowFromJSON(json['customWindow']),
    };
}

export function DrawQualificationToJSON(json: any): DrawQualification {
    return DrawQualificationToJSONTyped(json, false);
}

export function DrawQualificationToJSONTyped(value?: DrawQualification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scope': DrawQualificationScopeToJSON(value['scope']),
        'minPoints': value['minPoints'],
        'customWindow': DrawQualificationCustomWindowToJSON(value['customWindow']),
    };
}

